/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripePaymentMethodListResponse
 */
export interface StripePaymentMethodListResponse {
    /**
     * See https://stripe.com/docs/api/payment_methods/customer_list
     * @type {Array<object>}
     * @memberof StripePaymentMethodListResponse
     */
    paymentMethods: Array<object>;
}

/**
 * Check if a given object implements the StripePaymentMethodListResponse interface.
 */
export function instanceOfStripePaymentMethodListResponse(value: object): value is StripePaymentMethodListResponse {
    if (!('paymentMethods' in value) || value['paymentMethods'] === undefined) return false;
    return true;
}

export function StripePaymentMethodListResponseFromJSON(json: any): StripePaymentMethodListResponse {
    return StripePaymentMethodListResponseFromJSONTyped(json, false);
}

export function StripePaymentMethodListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripePaymentMethodListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethods': json['paymentMethods'],
    };
}

export function StripePaymentMethodListResponseToJSON(json: any): StripePaymentMethodListResponse {
    return StripePaymentMethodListResponseToJSONTyped(json, false);
}

export function StripePaymentMethodListResponseToJSONTyped(value?: StripePaymentMethodListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethods': value['paymentMethods'],
    };
}

